/**
 * Dictation vocabulary events (`docs/reference/observability-events.md`).
 * Counts and flags only: never the word, the mishearing or its neighbours.
 */
import { track } from "./observability";

const wordCount = (text: string) => text.split(/\s+/).filter(Boolean).length;

/** A word was added from the Vocabulary page or a Memory suggestion. */
export function trackVocabularyWordAdded(
  source: "settings" | "memory",
  text: string,
): void {
  track("desktop_voice_vocabulary_word_added", {
    source,
    word_count: wordCount(text),
  });
}

/** A correction was remembered from Recent dictations or a composer. */
export function trackVocabularyWordLearned(props: {
  surface: "recent_dictation" | "composer";
  heard: string;
  heardRealWord: boolean;
  newWord: boolean;
}): void {
  track("desktop_voice_vocabulary_word_learned", {
    surface: props.surface,
    heard_word_count: wordCount(props.heard),
    heard_real_word: props.heardRealWord,
    new_word: props.newWord,
  });
}
